import React, { useState, useRef, useEffect } from "react";
import {
  GoogleMap,
  LoadScript,
  Polygon,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { Link, useLocation, useHistory } from "react-router-dom";
import { Checkbox, Col, Row } from "antd";
import { useParams } from "react-router";
import { authenticateToken } from "../../utils/auth";
import ShopMarker from "../../images/icon/ShopMarker.svg";
import DriverMarker from "../../images/icon/DriverMarker.svg";
import OrderMarker from "../../images/icon/OrderMarker.svg";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const NeighborhoodMap = () => {
  const history = useHistory();
  const [path, setPath] = useState([]);
  const [neighborhoodTitle, setNeighborhoodTitle] = useState([]);
  const { neighborhoodId } = useParams();
  const { shopType } = useParams();
  const [shopList, setShopList] = useState([]);
  const [processingOrder, setProcessingOrder] = useState([]);
  const [onlineVehicle, setOnlineVehicle] = useState([]);
  const [shopShow, setShopShow] = useState(true);
  const [onlineOrderShow, setOnlineOrderShow] = useState(false);
  const [allOnlineVehicle, setAllOnlineVehicle] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null);
  const shopActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const orderActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };
  const deliveryBoyActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const fetchPolygons = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_CATALOG_READER_API}/neighborhood/internal?neighborhoodId=${neighborhoodId}`,
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    const response = await data.json();
    setPath(
      response.neighborhood.points.map((point) => ({
        lat: point.latitude,
        lng: point.longitude,
      }))
    );
    setNeighborhoodTitle(response.neighborhood);
  };

  const neighborhoodLastItem = path[path.length - 4];
  const position = {
    lat: neighborhoodLastItem?.lat,
    lng: neighborhoodLastItem?.lng,
  };
  const shopListWithNeighborhood = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/by-neighborhood?neighborhoodId=${neighborhoodId}&type=${shopType}`,
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    const shopResponse = await data.json();
    setShopList(shopResponse.shops);
  };

  const orderProcessingWithNeighborhood = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_ORDER_API}/admin/order/processing-order-by-neighborhood?neighborhoodId=${neighborhoodId}&type=${shopType}`,
      {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${authenticateToken()}`,
        },
      }
    );
    const orderResponse = await data.json();
    setProcessingOrder(orderResponse.orders);
  };
  const onlineVehicleWithNeighborhood = async () => {
    const data = await fetch(
      `${process.env.REACT_APP_RIDER_API}/vehicle/all-online?neighborhoodId=${neighborhoodId}`,
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    const vehicleResponse = await data.json();
    setOnlineVehicle(vehicleResponse.vehicleLocationList);
  };

  useEffect(() => {
    fetchPolygons();
    shopListWithNeighborhood();
    orderProcessingWithNeighborhood();
    onlineVehicleWithNeighborhood();
  }, []);

  return (
    <>
      <section className="">
        <Row gutter={20} width="full">
          <Col span={12}>
            <h3 className="mb-0">{neighborhoodTitle?.name} </h3>
          </Col>
          <Col span={12}>
            <div className="float-right">
              <Checkbox
                type="checkbox"
                defaultChecked={true}
                onChange={(val) => setShopShow(val.target.checked)}
              >
                Shop List
              </Checkbox>
              <Checkbox
                onChange={(val) => setOnlineOrderShow(val.target.checked)}
              >
                Processing Order
              </Checkbox>
              <Checkbox
                onChange={(val) => setAllOnlineVehicle(val.target.checked)}
              >
                Online Vehicle
              </Checkbox>
            </div>
          </Col>
        </Row>
      </section>
      <div className="add-product drawer-toggle-wrapper">
        <div className="drawer-toggle-inner-wrapper">
          <div className="bg-white p-3">
            <div className="details-area">
              <LoadScript
                id="script-loader"
                googleMapsApiKey="AIzaSyBAV5ux84Aast-onJ1DOq7uspbN6doNxXQ"
                language="en"
                region="us"
              >
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={position}
                  zoom={12}
                >
                  <Polygon
                    path={path}
                    options={{
                      strokeColor: "red",
                      strokeOpacity: 0.75,
                      strokeWeight: 2,
                      fillColor: "rgb(185 153 255 / 44%)",
                      fillOpacity: 0.6,
                      icons: [
                        {
                          // icon: lineSymbol,
                          offset: "0",
                          repeat: "20px",
                        },
                      ],
                    }}
                  />
                  {shopShow &&
                    shopList?.map((shop) => (
                      <Marker
                        icon={ShopMarker}
                        title={shop?.name}
                        position={{
                          lat: shop?.location?.y,
                          lng: shop?.location?.x,
                        }}
                        onClick={(e) => {
                          window.open(`/shops/${shop?.id}/details`, `_blank`);
                        }}
                      ></Marker>
                    ))}

                  {onlineOrderShow &&
                    processingOrder?.map((order) => (
                      <Marker
                        icon={OrderMarker}
                        title={order?.status}
                        position={{
                          lat: order?.shippingLocation?.latitude,
                          lng: order?.shippingLocation?.longitude,
                        }}
                        onClick={() => orderActiveMarker(order?.orderId)}
                      >
                        {activeMarker === order?.orderId ? (
                          <InfoWindow
                            onCloseClick={() => setActiveMarker(null)}
                          >
                            <div className="inner-body-wrapper">
                              <div className="inner-body">
                                <div className="single">
                                  <div className="info-name">
                                    <span>Order ID</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.orderId}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Base Order ID</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.baseOrderId}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Status</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.status}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Sub Total</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.subTotal}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Total</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.total}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Payment Method</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.paymentMethod}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>TokenNumber</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.tokenNumber}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Delivery Man ID</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.deliveryMan?.id}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Delivery Man Name</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{order?.deliveryMan?.name}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Delivery Man Mobile Number</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>
                                      <a href="tel:{order?.deliveryMan?.mobileNumber}">
                                        {order?.deliveryMan?.mobileNumber}
                                      </a>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </InfoWindow>
                        ) : null}
                      </Marker>
                    ))}

                  {allOnlineVehicle &&
                    onlineVehicle?.map((vehicle) => (
                      <Marker
                        icon={DriverMarker}
                        title={vehicle?.driver?.mobileNumber}
                        position={{
                          lat: vehicle?.location?.y,
                          lng: vehicle?.location?.x,
                        }}
                        onClick={() => deliveryBoyActiveMarker(vehicle?.id)}
                      >
                        {activeMarker === vehicle?.id ? (
                          <InfoWindow
                            onCloseClick={() => setActiveMarker(null)}
                          >
                            <div className="inner-body-wrapper">
                              <div className="inner-body">
                                <div className="single">
                                  <div className="info-name">
                                    <span>Driver ID</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{vehicle?.driverId}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Driver Name</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{vehicle?.driver?.name}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Driver Mobile Number</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>
                                      <a href="tel:{vehicle?.driver?.mobileNumber}">
                                        {vehicle?.driver?.mobileNumber}
                                      </a>
                                    </span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Status</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{vehicle?.status}</span>
                                  </div>
                                </div>
                                <div className="single">
                                  <div className="info-name">
                                    <span>Vehicle Type</span>
                                  </div>
                                  <div className="info-desc">
                                    <span>{vehicle?.vehicleType}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </InfoWindow>
                        ) : null}
                      </Marker>
                    ))}
                </GoogleMap>
              </LoadScript>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(NeighborhoodMap);
